import React, { Component } from "react";
import PropTypes from "prop-types";
import LoanCalculatorResults from "./LoanCalculatorResults";

class DetailsPanel extends Component {
  static propTypes = {
    loanCalculationResults: PropTypes.object.isRequired,
    pageContent:PropTypes.object.isRequired,
    onCloseResults: PropTypes.func.isRequired
  };

  render() {
    const { loanCalculationResults, pageContent, onCloseResults } = this.props;

    return (
      <LoanCalculatorResults
        loanCalculationResults={loanCalculationResults}
        pageContent={pageContent}
        onCloseResults={onCloseResults}
      />
    );
  }
}

DetailsPanel.propTypes = {};

export default DetailsPanel;
